export default `
mutation dadosPagValido(
    $idProposta: String
    $fingerprintSessionId: String
    $versaoTermoAceite: String
    $nome: String
    $bandeira: String
    $cvv: String
    $numeroMascarado: String
    $validade: String
    $paymentToken: String
    $codigoBanco: String
    $agencia: String
    $conta: String
    $digitoConta: String
    $formaPagamento: String
    $vencimentoFatura: Int
    $captchaResponse: String
    $gateways: [Gateway]
  ) {
    dadosPagValidoFCG(
      payload: {
        id: $idProposta
        captchaResponse: $captchaResponse,
        fingerprintSessionId: $fingerprintSessionId
        versaoTermoAceite: $versaoTermoAceite
        pagamento: {
          nome: $nome
          bandeira: $bandeira
          cvv: $cvv
          numeroMascarado: $numeroMascarado
          validade: $validade
          paymentToken: $paymentToken
          codigoBanco: $codigoBanco
          agencia: $agencia
          conta: $conta
          digitoConta: $digitoConta
          formaPagamento: $formaPagamento
          vencimentoFatura: $vencimentoFatura
          gateways: $gateways
        }
      }
    ) {
      dados {
        id
        situacaoProposta
      }
      validatorResponse {
        errors {
          message
          category
        }
      }
    }
  }
`;
